module.exports = "/_next/static/images/mv-0cdf2e4f742737da1d7339d50f04c332.svg";